import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './EditBlogRecipePage.scss';

interface Recipe {
    id: string;                      // Primary key (matches 'pk' in the JSON)
    type: 'recipe';                  // Discriminator for entity type
    recipe_name: string;             // Name of the recipe
    description: string;             // Description of the recipe
    ingredients: string[];           // List of ingredients
    instructions: string[];          // List of instructions
    tried: boolean;                  // Indicates if the recipe has been tried
    servings: string;
    prep_time: string;
    cook_time: string;
    total_time: string;
    nutrition_info: string;
    average_rating: string;          // Average rating as a string
    rating_count: number;            // Total number of ratings
    createdBy: string;
    user_ratings: {                  // Ratings given by individual users
        [key: string]: number;       // Key is the user ID, value is the rating
    };
}

  
interface Blog {
    id: string;
    type: 'blog';  // Discriminator
    title: string;
    description: string;
    content: string;
  }
  

interface EditPageProps {
  content?: Recipe | Blog;
}

type Content = Recipe | Blog;

const EditBlogRecipePage: React.FC<EditPageProps> = ({ content }) => {
    const [isBlog, setIsBlog] = useState(content?.type === 'blog');
    const [title, setTitle] = useState(content?.type === 'recipe' ? content.recipe_name : content?.title || '');
    const [description, setDescription] = useState(content?.description || '');
    const [ingredients, setIngredients] = useState(content?.type === 'recipe' ? content.ingredients : []);
    const [instructions, setInstructions] = useState(content?.type === 'recipe' ? content.instructions : []);
    const [blogContent, setBlogContent] = useState(content?.type === 'blog' ? content.content : '');
    const navigate = useNavigate();
  
    const handleSave = async () => {
      const payload = isBlog
        ? {
            title,
            description,
            content: blogContent,
          }
        : {
            recipe_name: title,
            description,
            ingredients,
            instructions,
          };
  
      try {
        if (content) {
          await axios.put(`/api/content/${content.id}`, payload);
        } else {
          await axios.post(`https://dw1271o3wa.execute-api.us-east-1.amazonaws.com/v1/tablefields`, payload);
        }
        navigate(`/content/${content?.id || 'new-id'}`);
      } catch (err) {
        alert('Failed to save content. Please try again later.');
      }
    };
  
    const handleConvertToBlog = () => {
      setIsBlog(true);
    };
  
    return (
      <div className="edit-blog-recipe">
        <h1>Edit {isBlog ? 'Blog' : 'Recipe'}</h1>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Title"
          className="edit-title"
        />
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description"
          className="edit-description"
        />
  
        {!isBlog && (
          <>
            <textarea
              value={ingredients.join('\n')}
              onChange={(e) => setIngredients(e.target.value.split('\n'))}
              placeholder="Ingredients (one per line)"
              className="edit-ingredients"
            />
            <textarea
              value={instructions.join('\n')}
              onChange={(e) => setInstructions(e.target.value.split('\n'))}
              placeholder="Instructions (one per line)"
              className="edit-instructions"
            />
            <button onClick={handleConvertToBlog} className="convert-to-blog">
              Convert to Blog
            </button>
          </>
        )}
  
        {isBlog && (
          <textarea
            value={blogContent}
            onChange={(e) => setBlogContent(e.target.value)}
            placeholder="Blog Content"
            className="edit-blog-content"
          />
        )}
  
        <button onClick={handleSave} className="cta-button save-button">
          Save
        </button>
      </div>
    );
  };
  
  export default EditBlogRecipePage;